<template>
  <el-container class="baohus" >
    <el-row :style="{'width': screenWidth+'px','height': screenHeight+'px','background-color': '#fff'}">
      <h2>【宇宙之幂】隐私保护政策</h2>
      <p>宇宙之幂（深圳）科技集团有限公司以及子公司（以下称为“我司”）尊重并保护所有使用【宇宙之幂】服务的用户（以下称为“您”）个人隐私与信息安全。鉴于此，我司制定《【宇宙之幂】隐私保护政策》（以下称为“本政策”）与您确认关于您使用服务期间，我司将收集、存储、使用和保护您的个人信息的相关事宜。本隐私权政策将帮助您了解以下内容：</p>
      <h4>第一条	法律声明</h4>
      <p>请您在使用【宇宙之幂】服务之前仔细阅读本政策之全部条款，并确认您已完全理解本政策之规定，浏览后使用【宇宙之幂】服务，表明您已阅读、理解并同意接受以下条款的约束，并遵守所有适用的法律法规。</p>
      <h4>第二条	信息收集范围</h4>
      <p>在您使用我们的服务时，您所处的地理位置信息。</p>
      <p>在您使用我们的服务时，我们还可能会记录您在使用我们的服务时提供、形成或留存的信息。</p>
      <h4>第三条	信息的使用</h4>
      <p>向您提供服务：我们使用您的个人数据完成并管理您的服务信息。</p>
      <p>数据分析：我们可能将您的服务信息用于分析，从而为您提供个性化的服务，向您推荐适合您的服务。</p>
      <h4>第四条	您的个人信息存储</h4>
      <p>请您知悉，我司就收集到的信息将统一默认存储在中华人民共和国境内的服务器内。</p>
      <h4>第五条	信息保障</h4>
      <p>我们将采取符合业界标准、合理可行的安全防护措施保护您提供的个人信息安全，防止您的个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。
      Hi兔的网络服务采取了传输层安全政策等加密技术，通过https等方式提供浏览服务，确保用户数据在传输过程中的安全。
      也请您使用复杂密码并妥善保管您的账户及密码，并谨慎向第三方提供您的个人信息。</p>
      <h4>第六条	本政策如何更新</h4>
      <p>我们的隐私政策可能变更。政策修改后，我们会在相关页面或其他合的方式向您展示变更后的政策。如果您不同意本政策的修改，请立即停止使用平台或取消已经获得的服务；如果您选择在本政策修改后继续访问或使用平台或服务的，则视为您已接受本政策的修改。</p>
      <h4>第七条	如何联系我们</h4>
      <p>如您有任何与个人信息保护或隐私保护相关的问题、意见或者建议，您可以发送邮件至我们个人信息保护负责人的邮箱universepower@universepowe.cn与我们联系。
      请您再次确认您已全部阅读并充分理解上述条款。</p>
    </el-row>
  </el-container>

</template>

<script>
  export default {
    data() {
      return {

        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,

      };
    },
  }
</script>

<style>
  h2{
  		text-align: center;
  	}
  	p{
  		margin:0 0 0 25px;
  		line-height: 25px;
  	}
  	h4{
  		margin:5 0 5 0;
  	}


</style>



// WEBPACK FOOTER //
// src/components/main/baohu.vue